import React from 'react';
import styled from 'astroturf/react';

import { ResearchInterest } from './index';
import _Container from "ResearchInterestSearchResults-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestSearchResults.tsx?styleId=Container";
import _ResultContainer from "ResearchInterestSearchResults-ResultContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestSearchResults.tsx?styleId=ResultContainer";
import _ResultName from "ResearchInterestSearchResults-ResultName.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestSearchResults.tsx?styleId=ResultName";
import _ResultWeight from "ResearchInterestSearchResults-ResultWeight.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/videos/shared/research_interest_tags/ResearchInterestSearchResults.tsx?styleId=ResultWeight";


interface Props {
  researchInterests: Array<ResearchInterest>;
  onAdd(ri: ResearchInterest): void;
}

const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const ResultContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ResultContainer",
  styles: _ResultContainer
});

const ResultName = /*#__PURE__*/styled("span", null, {
  displayName: "ResultName",
  styles: _ResultName
});

const ResultWeight = /*#__PURE__*/styled("span", null, {
  displayName: "ResultWeight",
  styles: _ResultWeight
});

export default function ResearchInterestSearchResults(props: Props) {
  const { researchInterests, onAdd } = props;

  const results = researchInterests.map((ri) => (
    <ResultContainer
      key={ri.id}
      onClick={() => onAdd(ri)}
      title={ri.displayName}
    >
      <ResultName>{ri.displayName}</ResultName>
      <ResultWeight>
        {ri.weight}&nbsp;{ri.weightDescription}
      </ResultWeight>
    </ResultContainer>
  ));

  return <Container>{results}</Container>;
}
